/** ISO 4217 → ISO 3166-1 alpha-2 for regional-indicator flag emoji (approximate). */
const CURRENCY_TO_TERRITORY: Record<string, string> = {
  USD: "US",
  EUR: "EU",
  GBP: "GB",
  JPY: "JP",
  AUD: "AU",
  NZD: "NZ",
  CAD: "CA",
  CHF: "CH",
  CNY: "CN",
  CNH: "CN",
  HKD: "HK",
  SGD: "SG",
  SEK: "SE",
  NOK: "NO",
  DKK: "DK",
  INR: "IN",
  TRY: "TR",
  MXN: "MX",
  ZAR: "ZA",
  PLN: "PL",
  HUF: "HU",
  RUB: "RU",
  BRL: "BR",
  KRW: "KR",
  TWD: "TW",
  THB: "TH",
  IDR: "ID",
  MYR: "MY",
  PHP: "PH",
  ILS: "IL",
  SAR: "SA",
  AED: "AE",
  CLP: "CL",
  COP: "CO",
  ARS: "AR",
  CZK: "CZ",
  RON: "RO",
};

function territoryFromCurrency(code: string): string | null {
  const c = code.trim().toUpperCase();
  return CURRENCY_TO_TERRITORY[c] ?? null;
}

function flagEmojiFromAlpha2(alpha2: string): string | null {
  const cc = alpha2.toUpperCase();
  if (!/^[A-Z]{2}$/.test(cc)) return null;
  /** Regional Indicator Symbols A–Z (avoid literal astral escapes for tooling). */
  const base = 0x1f1e6;
  const a = "A".charCodeAt(0);
  const codePoints = [...cc].map((ch) => base + ch.charCodeAt(0) - a);
  return String.fromCodePoint(...codePoints);
}

/**
 * Emoji flag when we can derive a territory; neutral symbol otherwise.
 */
export function currencyPairLabel(code: string): { flag: string; codeUpper: string } {
  const codeUpper = code.trim().toUpperCase();
  const terr = territoryFromCurrency(codeUpper);
  const emoji = terr ? flagEmojiFromAlpha2(terr) : null;
  const flag =
    emoji ?? "◆"; /** Small neutral marker when pairing is ambiguous (metal codes, crosses). */
  return { flag, codeUpper };
}
